<template>
  <div>

    <!-- 저장하기 버튼 -->
    <div class="btn-group-justify-end">
      <button class="button is-primary" @click="save">저장하기</button>
    </div>
    <div>
      <div class="columns is-multiline">

        <!-- 내부 플러그인 관리 -->
        <div class="column is-8">
          <div class="box">
            <admin-box-item title="런치팩 플러그인 관리"
                            :useTab="false">
              <div class="columns is-multiline">
                <lp-check-group :list="masterInternalPlugins"
                                :data="serviceInternalPlugins"
                                value_name="value"
                                label_name="label"></lp-check-group>
              </div>
            </admin-box-item>
          </div>
        </div>
        <!-- external 플러그인 관리 -->
        <!--<div class="column is-half">
          <div class="box">
            <admin-box-item title="써드파티 플러그인 관리"
                            :useTab="false">
              <div class="columns is-multiline">
                <div class="column is-full">
                  <div v-if="plugins === null">설치된 플러그인이 없습니다.</div>
                  <admin-form-item :label="plugin.plugin_key"
                  v-else
                    v-for="plugin in plugins" :key="plugin.plugin_id">
                    <div>
                      <div v-if="plugin.activated">사용중</div>
                      <div v-else>사용중이지 않음</div>
                      &lt;!&ndash; <lp-check-bool label="활성/비활성" :checkedVal.sync="plugin.activated"></lp-check-bool> &ndash;&gt;
                      <button @click="acvDeactvPlugin(plugin)">
                        {{ !plugin.activated ? "활성" : "비활성" }}
                      </button>
                      <div>
                      <button>삭제</button>
                    </div>
                    </div>
                  </admin-form-item>
                </div>
              </div>
            </admin-box-item>
          </div>
        </div>-->
      </div>
    </div>
  </div>
</template>

<script>
  import BreadCrumb from '../../module/common/BreadCrumb'
  import InputImg from '../../module/common/InputImg'
  import LpInputText from '../../module/common/LpInputText'
  import LpAddress from '../../module/common/LpAddress'
  import LpCheckBool from "../../module/common/LpCheckBool";
  import AdminFormItem from "../../module/admin/AdminFormItem";
  import LpCheckGroup from "../../module/common/LpCheckGroup";

  export default {
    layout: 'Main',
    components: {
      LpCheckGroup,
      AdminFormItem,
      LpCheckBool,

      InputImg,
      LpInputText,
      LpAddress
    },

    data() {
      return {
        serviceInternalPlugins: [],
        masterInternalPlugins: [],
        originMasterInternalPlugins: [],
        plugins: null,
      };
    },

    created() {
      this.getServiceInternalPlugins();

      /*this.$axios.get('admin/service/plugin').then(res => {
        if(res.status=== 200) {
          this.plugins=res.data;
        }
      });*/
    },

    watch: {
      serviceInternalPlugins(n) {
        if(n.indexOf('age_verify')===-1 && n.indexOf('identity_verify')===-1) {
          this.masterInternalPlugins = this.cloneItem(this.originMasterInternalPlugins);
        }
        n.forEach(name => {
          if(name==='age_verify') {
            let index = this.masterInternalPlugins.findIndex(item=>item.key==='identity_verify');
            if(index>-1) removeIndex(this.masterInternalPlugins, index);
          }
          else if(name==='identity_verify') {
            let index = this.masterInternalPlugins.findIndex(item=>item.key==='age_verify');
            if(index>-1) removeIndex(this.masterInternalPlugins, index);
          }
        })
      }
    },

    methods: {
      getServiceInternalPlugins () {
        let url = 'admin/service/internal_plugin';
        this.$axios.get(url)
          .then(res => {
            this.masterInternalPlugins = res.data.master_plugins;
            this.originMasterInternalPlugins = this.cloneItem(res.data.master_plugins);
            this.serviceInternalPlugins = res.data.plugins;
          })
      },
      save() {
        this.$axios.post('admin/service/internal_plugin', {
          internal_plugin: this.serviceInternalPlugins
        })
          .then(res => {
            if (res.status === 200) {
              this.toast('저장되었습니다.');
              this.$store.commit('setInternalPlugin', this.serviceInternalPlugins);
              //this.getMenus();
            }
          });
      },

      getMenus(){
        let url = ''
        if(this.$store.getters.mode==='admin')
          url = 'admin/menu';
        else
          url = 'partner/'+this.$store.getters.partner.partner_id+'/menu';
        // 메뉴 가져오기 (파트너랑 어드민)
        this.$axios.get(url)
          .then(res => {
              if(res.status === 200) {
                this.$store.commit('setMenus', res.data);
              }
            }
          )
          .catch(err => {
            this.adminOnError(err.response.status);
          });
      },

      acvDeactvPlugin(plugin) {
          //비활성
          this.$axios.patch('admin/service/plugin/' + plugin.plugin_id,
          {
            plugin_key: plugin.plugin_key,
            plugin_id: plugin.plugin_id,
            activated: !plugin.activated,
          }).then(res => {
            if (res.status===200){
              plugin.activated = !plugin.activated;
            }
          });
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  //@import '~assets/css/reset'
  //@import '~assets/css/lp_main'

  .btn-link
    border 1px solid #008fd9
    padding 4px 8px
    border-radius 3px
    font-size 0.7rem
    color: #008fd9
    display inline-block

  .btn-link:hover
    cursor pointer
    background-color #008fd9
    color #ffffff

  .desc
    font-size 0.8rem
    margin-top 4px
    color #787878

  #file
    position fixed
    bottom -100px
    left -100px

</style>
<style lang="stylus">
  .lp-check-container
    margin-bottom 12px
  .lp-label
    width 140px
</style>
